<div class="content-full message release-view d-flex flex-column h-100">
    @if (message) {
        <kno2-message-action-bar
            class="mt-n3"
            [message]="message"
            [attachments]="attachments"
            [patientIntegrationMeta]="patientIntegrationMeta()"
            [deliverySummaryEnableDownload]="deliverySummaryEnableDownload()" />

        <div class="row">
            <div class="col-sm-9 col-lg-8 col-xl-8 col-no-padding d-flex flex-column">
                <div class="header pt-2 border-bottom-0">
                    @if (error()?.title) {
                        <kno2-notification-alert
                            type="danger"
                            [title]="error().title"
                            [messages]="error().messages"
                            (dismiss)="clearError()" />
                    }
                    @if (serverError()) {
                        <div class="mb-2">
                            <kno2-notification-alert
                                type="danger"
                                [title]="serverError()" />
                        </div>
                    }
                    <kno2-release-address-panel />
                </div>

                <div class="doc-container d-flex flex-column box">
                    <div class="d-flex align-items-center justify-content-between mb-3 box-header">
                        <h2 class="my-2 fw-bold">
                            {{ showDocumentViewer() ? "Attachment Preview" : "Message Body" }}
                        </h2>
                        @if (responseType === "forward") {
                            <div
                                class="btn-group h-100"
                                role="group">
                                <button
                                    type="button"
                                    class="btn rounded-0 no-hover"
                                    data-bs-toggle="tooltip"
                                    title="Message Body"
                                    [class.btn-primary]="!showDocumentViewer()"
                                    [class.btn-outline-primary]="showDocumentViewer()"
                                    (click)="showDocumentViewer.set(false)">
                                    <i class="fa fa-file-text-o"></i>
                                </button>
                                <button
                                    type="button"
                                    class="btn rounded-0 no-hover"
                                    data-bs-toggle="tooltip"
                                    title="Attachment Preview"
                                    [class.btn-primary]="showDocumentViewer()"
                                    [class.btn-outline-primary]="!showDocumentViewer()"
                                    (click)="showDocumentViewer.set(true)">
                                    <i class="fa fa-file-image-o"></i>
                                </button>
                            </div>
                        }
                    </div>

                    @if (!showDocumentViewer()) {
                        <textarea
                            [formControl]="form.get('body')"
                            class="w-100"
                            id="messageBodyTextarea"
                            style="resize: none"
                            tabindex="1"
                            kno2GrowTo="footer"></textarea>
                    } @else {
                        <div
                            class="doc-viewer"
                            id="doc-viewer">
                            <kno2-pdf-viewer-container
                                [attachment]="selectedAttachment()"
                                [options]="viewerOptions()" />
                        </div>
                    }
                </div>
            </div>
            <div class="col-sm-3 col-lg-4 col-xl-4 auto-fill intake-right-border col-no-gutters d-flex flex-column">
                <kno2-message-patient-details
                    [integrationName]="capabilities()?.displayName"
                    [(patientIntegrationMeta)]="patientIntegrationMeta"
                    [capabilities]="capabilities()?.capabilities"
                    [hasExternalLogin]="capabilities()?.externalLogin"
                    [showPatientLookup]="true"
                    [showVisitLookup]="true"
                    [showVisitDetails]="true" />
                <div class="flex-grow-1 mb-5">
                    <kno2-message-patient-attachments
                        [(attachments)]="attachments"
                        [(selectedAttachment)]="selectedAttachment"
                        [patientIntegrationMeta]="patientIntegrationMeta()"
                        [integrationName]="capabilities()?.displayName"
                        [capabilities]="capabilities()?.capabilities"
                        [hasExternalLogin]="capabilities()?.externalLogin"
                        [documentTypes]="documentTypes()"
                        [showAddAttachment]="true"
                        [showRenameAttachment]="false"
                        [showDeleteAttachment]="true"
                        [showOrderLookup]="responseType === 'reply'" />
                </div>
            </div>
        </div>
    }
</div>
